(function ($) {
    var seedCount;
    var seedWeight;
    var seedGermination;

    $(document).ready(function() {
        if ($('.page-template-template-calculators').length) {
            seedCount = new Cleave('#seed-count', {
                numeral: true,
                numeralPositiveOnly: true,
                stripLeadingZeroes: false
            });

            seedWeight = new Cleave('#seed-weight', {
                numeral: true,
                numeralPositiveOnly: true,
                stripLeadingZeroes: false
            });

            seedGermination = new Cleave('#seed-germination', {
                numeral: true,
                numeralPositiveOnly: true,
                stripLeadingZeroes: false
            });
        }
    });

    $('.calculator-section .calculator[data-calculator="seeds"] .calculator-submit').on('click', function() {
        var calculator = $(this).closest('.calculator');
        var resultWrap = calculator.find('.result-block .result-wrap');
        var seedCountInput = calculator.find('#seed-count');
        var seedWeightInput = calculator.find('#seed-weight');
        var seedGerminationInput = calculator.find('#seed-germination');

        seedCountInput.parent().removeClass('error');
        seedWeightInput.parent().removeClass('error');
        seedGerminationInput.parent().removeClass('error');

        resultWrap.find('.result-number').text('');
        resultWrap.addClass('hidden');
        resultWrap.removeClass('small-text');

        var valid = true;

        if (!seedCount.getRawValue()) {
            seedCountInput.parent().addClass('error');
            valid = false;
        }

        if (!seedWeight.getRawValue()) {
            seedWeightInput.parent().addClass('error');
            valid = false;
        }

        if (!seedGermination.getRawValue() || seedGermination.getRawValue() > 100) {
            seedGerminationInput.parent().addClass('error');
            valid = false;
        }

        if (valid) {
            var result = seedCount.getRawValue() * seedWeight.getRawValue() * (1 + ((100 - seedGermination.getRawValue()) * 2 * 0.01));

            resultWrap.find('.result-number').text(result.toFixed(1));

            if (result >= 1000) {
                resultWrap.addClass('small-text');
            }

            resultWrap.removeClass('hidden');
        }
    })
})(jQuery);